export default function (url, method, body) {
  const options = {
    method: method,
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    body: JSON.stringify(body)
  }
  return fetch(url, options)
    .then(response => {
      if (response.status >= 200 && response.status < 300)
        return Promise.resolve(response)
      return Promise.reject(new Error(response.statusText))
    })
    .then(response => response.json())
    .catch(err => {
      console.log('Fetch Error :-S', err);
    })
}
